// @flow

import { combineReducers } from 'redux';
import { routerReducer, LOCATION_CHANGE } from 'react-router-redux';
import { reducer as formsReducer } from 'redux-form';

import applicationReducer from './application';
import payerReducer from './payer';
import resourcesReducer from './resources';

const appReducer = combineReducers({
  application: applicationReducer,
  form: formsReducer,
  resources: resourcesReducer,
  router: routerReducer,
  payer: payerReducer,
});

// every page is currently responsible for getting its own data,
// so we erase state when location changes
const rootReducer = (state: any, action: any) => {
  let s = state;
  if (action.type === LOCATION_CHANGE) {
    s = undefined;
  }

  return appReducer(s, action);
};

export default rootReducer;

// TODO - update types
export type StateType = {
  application: any,
  form: any,
  router: any,
  payer: any,
  resources: any,
};



// WEBPACK FOOTER //
// ./src/reducers/index.js